import React from 'react';

const VehicleCell = ({ value }) => (
  <td>
    <span className="text-uppercase">{formatMessage(value, false, false)}</span>
  </td>
);

const VehicleCellEdit = ({ value }) => (
  <td>
    <span className="text-uppercase">{formatMessage(value, true, false)}</span>
  </td>
);

const VehicleCellError = ({ value }) => (
  <td>
    <span className="text-uppercase">{formatMessage(value, false, true)}</span>
  </td>
);

export const MASSIVE_CHANGE_TYPES = {
  VEHICLES_REMOVE: [
    {
      id: 'serialNumber',
      label: 'No. de serie',
      field: 'serialNumber',
      renderer: VehicleCell,
    }
  ],
  VEHICLES_REMOVE_ERROR: [
    {
      id: 'serialNumber',
      label: 'No. de serie',
      field: 'serialNumber',
      renderer: VehicleCell,
    },
    {
      id: 'error',
      label: 'Error(es)',
      field: 'error',
      renderer: VehicleCellError,
    }
  ],
  VEHICLES_EDIT: [
    {
      id: 'serialNumber',
      label: 'No. de serie',
      field: 'serialNumber',
      renderer: VehicleCell,
    },
    {
      id: 'category',
      label: 'Categoría nueva',
      field: 'category.name',
      renderer: VehicleCellEdit,
    },
    {
      id: 'subcategory',
      label: 'Subcategoría nueva',
      field: 'subcategory.name',
      renderer: VehicleCellEdit,
    }
  ],
  VEHICLES_EDIT_ERROR: [
    {
      id: 'serialNumber',
      label: 'No. de serie',
      field: 'serialNumber',
      renderer: VehicleCell,
    },
    {
      id: 'error',
      label: 'Error(es)',
      field: 'error',
      renderer: VehicleCellError,
    }
  ]
};

const formatMessage = (message, edit, error) => {

  if (message === null || message === undefined) {
    return edit ? "* Sin cambios *" : '';
  }

  if (error) {

    const parts = message.split(',');

    return parts.map((part, i) => (
      <React.Fragment key={i}>&bull;{' '}
        {part.replace("[", "").replace("]", "")}
        {i < parts.length - 1 && <br/>}
      </React.Fragment>
    ));

  }else{
    return message;
  }
}